














import { Component, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PdQualityControlSet from "./pdQualityControlSet/index.vue";
import PdQualityControlReminder from "./pdQualityControlReminder/index.vue";
import PdNursingQualityControlRepor from "./pdNursingQualityControlRepor/index.vue";
import PdHospitalizationSummary from "./pdHospitalizationSummary/index.vue";
import PdSummary from "./pdSummary/index.vue";
@Component({})
export default class PdQualityControlManage extends AbpBase {
  currentTab: string = "tabPdSummary";
  tabs: any = [
    {
      name: "tabPdSummary",
      label: "汇总表",
      component: PdSummary
    },
    {
      name: "tabPdHospitalizationSummary",
      label: "住院汇总表",
      component: PdHospitalizationSummary
    },
    {
      name: "tabPdNursingQualityControlRepor",
      label: "护理质控报表",
      component: PdNursingQualityControlRepor
    },
    {
      name: "tabPdPdQualityControlReminder",
      label: "质控提醒",
      component: PdQualityControlReminder
    },
    {
      name: "tabPdPdQualityControlSet",
      label: "质控设定",
      component: PdQualityControlSet
    }
  ];

  //点击tab时才显示页面
  handleClickTab(tabName: string) {
    this.currentTab = tabName;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdQualityControlManage/index.vue